import React from 'react';
import { RoleSelectionViewModel } from '../../../apollo/queries/getAllRoles.queries';
import { Category, defaultSelectedCategory } from '../hooks/useRoles';
import { Role, RoleSelection, ToggleSelectedRole } from '../roles.types';

export type Organisation = {
  code: string;
};

export type RolesContextType = {
  roleSelectionViewModel: RoleSelectionViewModel[];
  roles: Role[];
  selectedRolesCategories: string[];
  selectedCategory: Category;
  organisation: Organisation;
  onCategorySelect: (category: Category) => void;
  onToggleSelectedRole: ToggleSelectedRole;
};

export const RolesContext = React.createContext<RolesContextType>({
  roleSelectionViewModel: [],
  roles: [],
  selectedRolesCategories: [],
  organisation: { code: '' },
  selectedCategory: defaultSelectedCategory,
  onCategorySelect: (category: Category) => {},
  onToggleSelectedRole: (role: RoleSelection) => {},
});

export const useRolesContext = () => React.useContext(RolesContext);
